import { safeJsonParse } from "@swiggy-private/core-ui";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const modifySplashLottieText = (lottieData: any, totalSavings: number): any => {
    if (!lottieData || !lottieData.layers) {
        return lottieData;
    }

    const clonedData = safeJsonParse(JSON.stringify(lottieData), lottieData);

    // Find the layer named "SavingsCallout1" and replace its text
    clonedData.layers.forEach((layer: { nm?: string; t?: { d: { k: any[] } } }) => {
        if (layer.nm === "SavingsCallout1" && layer.t?.d?.k) {
            // Update all keyframes
            layer.t.d.k.forEach((keyframe: any) => {
                // eslint-disable-line @typescript-eslint/no-explicit-any
                if (keyframe.s?.t) {
                    keyframe.s.t = keyframe.s.t.replace("SAVINGS_AMOUNT", totalSavings);
                }
            });
        }
    });

    return clonedData;
};
